import { IPcbLineShapeStyles, LayerOrientation } from "@buildwithflux/models";
import { Vector2 } from "three";
import { CurveDivisions } from "../../../../fills";
import { createCircleOrOblongShape } from "../../../../shapes";
import { createDashedTracer } from "./support/dashedTracer";
import { getModule, toMm } from "./support/utils";
export const mapCircle = (circle, context, postprocess) => {
    const bakedRules = circle.bakedRules;
    if (!bakedRules) {
        return null;
    }
    const scale = bakedRules.scale.x;
    const layer = bakedRules.layer === LayerOrientation.top ? "F.SilkS" : "B.SilkS";
    postprocess((mapped) => {
        if (!mapped) {
            return;
        }
        const module = getModule(bakedRules.layer, context);
        const path = createCircleOrOblongShape(bakedRules.size, bakedRules.positionRelativeToDocument, bakedRules.rotationRelativeToDocument.z, CurveDivisions, undefined, bakedRules.scale);
        module.fp_poly = module.fp_poly ?? [];
        if (bakedRules.strokeStyle === IPcbLineShapeStyles.dashed) {
            const { shape, dashes } = createDashedTracer(path, bakedRules);
            // TODO: dedupe with mapRectangle()
            module.fp_poly = module.fp_poly.concat(dashes.map(({ angle, position }) => ({
                pts: shape
                    .map((point) => point
                    .clone()
                    .rotateAround(new Vector2(0, 0), angle)
                    .add(new Vector2(position.x, position.y)))
                    .map((point) => ({
                    x: toMm(point.x),
                    y: -toMm(point.y),
                })),
                layer: bakedRules.layer === LayerOrientation.top ? "F.SilkS" : "B.SilkS",
                width: 0,
            })));
        }
        else {
            const pts = [];
            const ptsInner = [];
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            path.getPoints(CurveDivisions).forEach((point, index, array) => {
                // Need to skip last point if we're at the starting index to avoid duplicate start/end point,
                // seeing that points of createCircleOrOblongShape(..) duplicate start/end
                const next = array.at(index === 0 ? index - 2 : index - 1);
                if (!next) {
                    return;
                }
                const tangent = new Vector2(next.x - point.x, next.y - point.y);
                const normal = new Vector2(tangent.y, -tangent.x);
                normal.setLength((bakedRules.strokeWidth ?? 0) * 0.5 * scale);
                pts.push({
                    x: toMm(point.x + normal.x),
                    y: -toMm(point.y + normal.y),
                });
                ptsInner.push({
                    x: toMm(point.x - normal.x),
                    y: -toMm(point.y - normal.y),
                });
            });
            // Reverse the inner points and append to the outer points to achieve
            // a double sided polygon that traces the contour of the circle shape
            ptsInner.reverse();
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            ptsInner.forEach((point) => {
                pts.push(point);
            });
            module.fp_poly.push({
                pts,
                layer,
                width: 0,
            });
        }
    });
    return {
        // ...position,
        center: { x: 0, y: 0 },
        end: { x: 0, y: 0 },
        //
        fill: "none",
        layer,
        width: 0,
    };
};
//# sourceMappingURL=mapCircle.js.map